import React, { FC, useEffect, useMemo, useState } from 'react';
import { getNetworkEnum } from '@helpers/address';
import { Spacer, LoaderOverlay, TableController } from '@rubin-dev/goblin';
import { useTranslation } from 'react-i18next';
import { useExplorerClusterAddressListQuery } from '@apolloGenerated';
import styles from './styles.module.scss';
import { renderCellHash } from '@shared/ui';

export type BtcAddressTableProps = {
  wid: string;
  network: string;
  updateTotal?: (total: number | string) => void;
};

const pageSize = 10;

export const ExplorerClusterAddresses: FC<BtcAddressTableProps> = ({
  wid,
  network,
  updateTotal,
}) => {
  const networkEnum = getNetworkEnum(network);
  const { t } = useTranslation();

  const [page, setPage] = useState(1);

  const { loading, data } = useExplorerClusterAddressListQuery({
    variables: {
      req: {
        network: networkEnum,
        pageSize,
        page,
        cluster: wid,
      },
    },
  });

  const items = useMemo(
    () =>
      (data?.explorerClusterAddressList?.edge || []).map(({ address }) => {
        return {
          address: renderCellHash({
            hash: address,
            type: 'address',
            network,
            longer: true,
          }),
          key: address,
        };
      }),
    [data],
  );
  const total = useMemo(
    () => data?.explorerClusterAddressList?.pager?.total || 0,
    [data],
  );

  useEffect(() => {
    if (updateTotal) {
      updateTotal(total);
    }
  }, [total]);

  const headers = [
    { title: t('titles.address'), value: 'address' },
    { hide: true, key: true, value: 'key' },
  ];

  return (
    <>
      <Spacer size={8} />
      <div className={styles.clusterAddresses__content}>
        <TableController
          data={items}
          headers={headers}
          initPage={page}
          total={Number(total)}
          onChangePage={setPage}
          pageSize={pageSize}
        />
      </div>
      <LoaderOverlay show={loading} />
    </>
  );
};
